import {
  otmsHttp,
  bfsUserWebHttp,
  wmsHttp,
  bmsLegacyTokenHttp,
} from '@/utils/http/index';

// 分页获取数据信息
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/17221  noPrefixHttp
export function tenantPage(data, query) {
  return bfsUserWebHttp.post('/bfs-user/tenant/v2/page', data, {
    params: {
      ...query,
      sort: 'create_time__DESC',
    },
  });
}

/**
 * 租户树查询V2
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/13974
 */
export const selectTenantAllTreeV2 = (data) => bfsUserWebHttp.post('/bfs-user/tenant/tree', data);

/**
 * @description 查询配置中心配置
 * @api https://yapi.ops.yunlizhi.cn/project/194/interface/api/18769
 */
export const getConfigCenterList = (data) => otmsHttp.post('/bfs-config/config_center/page', data);

/**
 * 根据条件分页查询租户
 *
 */
export const selectListByPage = (data, params) => bfsUserWebHttp.post('/bfs-user/tenant/page', data, { params });
/**
 * 根据条件分页查询 预对账卡控
 *
 */
export const reconciliationConfigPage = (data, params) => bmsLegacyTokenHttp.post('/bms_web_plus/bfs_pricing_rule/pre_reconciliation_config/page_query', data, { params });
/**
 * 根据条件分页编辑 预对账卡控
 *
 */
export const reconciliationConfigEdit = (data) => bmsLegacyTokenHttp.post('/bms_web_plus/bfs_pricing_rule/pre_reconciliation_config/batch_upsert', data);
/**
 * 根据条件分页编辑 预对账卡控
 *
 */
export const reconciliationConfigQuery = (data) => bmsLegacyTokenHttp.post('/bms_web_plus/bfs_pricing_rule/pre_reconciliation_config/tenant_dimension_query', data);
/**
 * 根据条件分页编辑 预对账卡控
 *
 */
export const reconciliationConfigConfig = (data) => bmsLegacyTokenHttp.post('/bms_web_plus/bfs_pricing_rule/pre_reconciliation_config/tenant_dimension_config', data);

/**
 * @description 查询租户列表
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/8432
 */
export const getTenantList = (data) => bfsUserWebHttp.post('/bfs-user/tenant/list', data);

/**
 *  查询认证企业列表（支持模糊)
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/15677
 */
export const referMerchantList = (data) => bfsUserWebHttp.post('/bfs_merchant/open/merchant/corp/list', data);

// 组织接口信息相关接口

/**
 *  通过租户ID获取当前租户组织(租户，以及部门信息)信息
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/13142
 */
export const getByTenantId = (data) => bfsUserWebHttp.post('/tenant/organization/get_by_tenant_id', data);

/**
 *  新增/修改部门信息
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/13144
 */
export const updateOrganization = (data) => bfsUserWebHttp.post('/tenant/organization/upsert_dep', data);

/**
 *  修改组织状态(删除) 后端无法给穿透  手动加/bfs_user
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/13238
 */
export const updateOrganizationStatus = (data) => bfsUserWebHttp.post('/bfs_user/organization/update_status', data);

/**
 * 新增/修改信息
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/15763
 */
export const upsert = (data) => bfsUserWebHttp.post('/bfs-user/tenant/upsert2', data);

/**
 * 变更上级租户
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/38788
 */
export const parentChange = (data) => bfsUserWebHttp.post('/bfs-user/tenant/parent/change', data);

// 新注销数据
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/673
export const cancelRequest = (data) => bfsUserWebHttp.post('/bfs-user/tenant/disable', data);

// 新启用数据
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/677
export const startBtnRequest = (data) => bfsUserWebHttp.post('/bfs-user/tenant/enable', data);

/**
 * 根据租户ID,查询操作日志
 * @param data
 * @param params
 */
export const selectLogsByTenantId = (data, params) => bfsUserWebHttp.post('/bfs-operate-log/operate-log/list', data, { params });

/**
 * 租户删除
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/23155
 * @param data
 */
export const deleteByIdCope = (data) => bfsUserWebHttp.post('/bfs-user/tenant/discard', data);

// 租户创建或者修改 noPrefixHttp
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/17219
export function tenantUpsert(data) {
  return bfsUserWebHttp.post('/bfs-user/tenant/v2/upsert', data);
}

// 获取对应的详情信息
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/17223
export function tenantInfo(data) {
  return bfsUserWebHttp.post('/bfs-user/tenant/v2/info', data);
}

// 组织树查询
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/13236
export function organizationTree(data) {
  return bfsUserWebHttp.post('/bfs-user/organization/tree2', data);
}
// 租户状态变更
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/17325
export function statusUpdate(data) {
  return bfsUserWebHttp.post('/bfs-user/tenant/v2/status/update', data);
}

// 列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/cat_8159
export function operatorLogPage(data, query) {
  return bfsUserWebHttp.post('/bfs-user/operator_log/page', data, {
    params: {
      ...query,
      sort: 'create_time__DESC',
    },
  });
}

/**
 * 查询当前机构下自己拥有或创建的角色
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/17983
 */
export function getTeantRoles(data) {
  return otmsHttp.post('/permission-plus/tenant/role/list', data);
}

/**
 * 绑定租户角色
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/17985
 */
export function bindTeantRoles(data) {
  return otmsHttp.post('/permission-plus/tenant/role/bind', data);
}

/**
 * 获取角色列表
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/10152
 */
export function getRoleList(data, params) {
  return otmsHttp.post('/permission-plus/role/tenant_role/page', data, {
    params,
  });
}

/**
 * 租户管理 新增/修改
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/15763
 */
export function upsertTenant(data, params) {
  return otmsHttp.post('/bfs-user/tenant/upsert2', data, {
    params,
  });
}
/**
 * 租户管理 获取租户详情
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/20185
 */
export function getTenantDetail(data, params) {
  return otmsHttp.post('/bfs-user/tenant/detail', data, {
    params,
  });
}
/**
 * 租户管理 租户禁用
 */
export function tenantDisable(data, params) {
  return otmsHttp.post('/bfs-user/tenant/disable', data, {
    params,
  });
}
/**
 * 租户管理 租户启用
 */
export function tenantEnable(data, params) {
  return otmsHttp.post('/bfs-user/tenant/enable', data, {
    params,
  });
}

/**
 * 系统菜单
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/18949
 * @param data
 * @returns {*}
 */
export const tenantSystemList = (data) => otmsHttp.post('/permission-plus/system/list', data);

/**
 * 获取用户列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/6065
 * @param data
 * @param params
 * @returns {*}
 */
export const tenantUserPage = (data, params) => bfsUserWebHttp.post('/bfs-user/tenant_user/page', data, { params });

/**
 * 获取已有租户角色列表 权限绑定
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/17983
 * @param data
 * @returns {*}
 */
export const fetchTenantRoleList = (data) => bfsUserWebHttp.post('/permission-plus/tenant/role/list', data);

/**
 * 租户用户更新基本信息 管理员用户
 * @param data
 * @returns {*}
 */
export const changeTenantAdmin = (data) => bfsUserWebHttp.post('/tenant_user/upsert', data);

/**
 * 获取当前租户已绑定用户列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/19337
 * @param data
 * @returns {*}
 */
export const authorizedTenantAdmin = (data) => bfsUserWebHttp.post('/bfs-user/tenant_user/authorized_user/page', data);

/**
 * 租户列表
 */
export function selectNewListByPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/page', data, {
    params,
  });
}

/**
 * 新-禁用
 * // https://yapi.ops.yunlizhi.cn/project/10/interface/api/201
 */
export function stopRequest(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/disable', data, {
    params,
  });
}
/**
 * 新-启用
 * // https://yapi.ops.yunlizhi.cn/project/10/interface/api/205
 */
export function startRequest(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/enable', data, {
    params,
  });
}

// /**
//  * @description 通过租户ID获取当前租户组织(租户，以及部门信息)信息
//  * https://yapi.ops.yunlizhi.cn/project/154/interface/api/13142
//  */
// export function getByTenantId(data, params) {
//   return bfsUserWebHttp.post('/tenant/organization/get_by_tenant_id', data, {
//     params,
//   });
// }
/**
 * @description 创建/修改租户用户 (文档字段可能跟实际不符合，只因为经过了转化，按实际编写的来)
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/13306
 */
export function upsertTenantUser(data, params) {
  return bfsUserWebHttp.post('/tenant_user/upsert', data, {
    params,
  });
}
/**
 * @description 查询用户详情
 * https://yapi.ops.yunlizhi.cn/project/154/interface/api/13364
 */
export function searchTenantUser(data, params) {
  return bfsUserWebHttp.post('/tenant_user/detail', data, {
    params,
  });
}

/**
 * 权限管理---用户管理界面
 * 导出接口  /permission/function/export
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/10916
 */
export function functionExport(data) {
  return otmsHttp.request({
    url: '/permission/function/export',
    data,
    method: 'POST',
    type: 'download',
  });
}

/**
 * 权限管理---用户管理界面
 * 判断导出接口的数据量大小是否超过25000条  /permission/function/export/count
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/10926
 */
export function functionExportCount(data) {
  return otmsHttp.request({
    url: '/permission/function/export/count',
    data,
    method: 'POST',
  });
}

/**
 * @description 分页查询租户下授权的用户信息
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/19337
 */
export function getAuthorizedUserPage(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/authorized_user/page', data, {
    params,
  });
}

/**
 * @description 日志-分页列表查询
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/6812
 */
export function getUserOperatorLogPage(data, params) {
  return otmsHttp.post('/bfs_user/user/operator_log/page', data, {
    params,
  });
}

/**
 * @description 打卡日志-分页列表查询
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/40223
 */
export function getUserSignDataLogPage(data, params) {
  return otmsHttp.post('/bfs_user/user/workbench/log/page', data, {
    params,
  });
}

/**
 * @description 租户用户重置密码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/6812
 */
export function resetTenantUserPassword(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/reset_pwd', data, {
    params,
  });
}

/**
 * @description 租户用户注册
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/6029
 */
export function registerTenantAdmin(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/register', data, {
    params,
  });
}

/**
 * @description 租户管理员绑定解绑
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/23267
 */
export function unBindTenantAdmin(data, params) {
  return bfsUserWebHttp.post('/bfs_user/tenant_user/tenant_admin/change', data, {
    params,
  });
}

/**
 * 获取租户属性 https://yapi.ops.yunlizhi.cn/project/10/interface/api/19481
 * @param data
 * @returns {*}
 */
export const getTenantPropertyList = (data) => bfsUserWebHttp.post('/bfs_user/tenant_property/list', data);

/**
 * 获取租户属性 https://yapi.ops.yunlizhi.cn/project/10/interface/api/19479
 * @param data
 * @returns {*}
 */
export const bindTenantProperty = (data) => bfsUserWebHttp.post('/bfs_user/tenant_property/upsert', data);

/**
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/13940
 * 根据租户集合查询仓库列表，使用id、warehouseCode
 */
export function getWarehouseListByTenantIds(data) {
  return wmsHttp.post('/warehouse_foundation/warehouse/list', data);
}

/**
 * @description 分子公司分页列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/43887
 */
export function fetchCompanyList(data, params) {
  return bfsUserWebHttp.post('/bfs_user/sub_company/list', data, {
    params,
  });
}
